import { render, staticRenderFns } from "./tool-details.vue?vue&type=template&id=086c3ec6&scoped=true"
import script from "./tool-details.vue?vue&type=script&lang=js"
export * from "./tool-details.vue?vue&type=script&lang=js"
import style0 from "./tool-details.vue?vue&type=style&index=0&id=086c3ec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086c3ec6",
  null
  
)

export default component.exports